import textPromoTitleL from '@fukku/styles/texts/textPromoTitleL.module.css'

import { cx } from 'classix'
import {
	type HeroBannerPromo,
	HeroBannerPromoType,
} from '../../../../Home.type'
import styles from './HeroBannerPromoGeneral.module.css'

interface HeroBannerPromoGeneralProps {
	readonly section: HeroBannerPromo
}

export function HeroBannerPromoGeneral({
	section,
}: HeroBannerPromoGeneralProps) {
	if (section.promoType !== HeroBannerPromoType.general) {
		return null
	}

	const {
		promoTitles: { title, discount },
	} = section

	return (
		<div className={cx(styles.titles, textPromoTitleL.className)}>
			<h2 className={styles.titlesWrapper}>
				<div>{title}</div>
				<div>{discount}</div>
			</h2>
		</div>
	)
}
